import './VisuallyHidden.css';
export var visuallyHidden = '_1xz8nhz0-3-12-1';